import { IOffer } from '../../offer';
import { TThunkAction, TThunkDispatch } from '../../types/redux';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

import type { TContactParam as TNewbuildingContact } from '@cian/newbuilding-chat-component';

export enum EChatActionTypes {
  Open = 'Chat/Open',
  OpenChatbot = 'Chat/OpenChatbot',
  OpenNewbuildingChat = 'Chat/OpenNewbuildingChat',
  Close = 'Chat/Close',
  OpenAfterAuth = 'Chat/OpenAfterAuth',
  OpenNewbuildingChatAfterAuth = 'Chat/OpenNewbuildingChatAfterAuth',
  SetNewbuildingChatButtonClicked = 'Chat/SetNewbuildingChatButtonClicked',
}

type TOpenChatPayload = {
  offer: IOffer;
  position: number;
  isEarlyAccess?: boolean;
  placeType?: string;
};

type TOpenChatAfterAuthPayload = {
  offer: IOffer;
  position: number;
  placeType?: string;
};

type TOpenNewbuildingChatPayload = {
  newbuildingContact: TNewbuildingContact;
  placeType: string;
};

type TOpenNewbuildingChatAfterAuthPayload = TOpenNewbuildingChatPayload;

export type TOpenChat = ITypedReduxAction<EChatActionTypes.Open, TOpenChatPayload>;
export type TOpenChatAfterAuth = ITypedReduxAction<EChatActionTypes.OpenAfterAuth, TOpenChatAfterAuthPayload>;
export type TOpenChatbot = ITypedReduxAction<EChatActionTypes.OpenChatbot, void>;
export type TCloseChat = ITypedReduxAction<EChatActionTypes.Close>;

/**
 * Action открытия чата по объявлению.
 * @param TOpenChatPayload
 */
export const openChat: (payload: TOpenChatPayload) => TOpenChat = actionGenerator<
  EChatActionTypes.Open,
  TOpenChatPayload
>(EChatActionTypes.Open);

/**
 * Action открытия чатбота
 * @param TOpenChatPayload
 */
export const openChatbot: () => TOpenChatbot = actionGenerator<EChatActionTypes.OpenChatbot, void>(
  EChatActionTypes.OpenChatbot,
);

/** Action открытия чата по ЖК. */
export const openNewbuildingChat = actionGenerator<EChatActionTypes.OpenNewbuildingChat, TOpenNewbuildingChatPayload>(
  EChatActionTypes.OpenNewbuildingChat,
);

/**
 * Callback авторизации при попытке открыть чаты
 * @param TOpenChatPayload
 */
export const onChatSuccessAuth = (payload: TOpenChatPayload) => (): TThunkAction => (dispatch: TThunkDispatch) =>
  dispatch(openChat(payload));

/**
 * Action открытия чата по объявлению после авторизации
 * @param TOpenChatAfterAuthPayload
 */
export const openChatAfterAuth: (payload: TOpenChatAfterAuthPayload) => TOpenChatAfterAuth = actionGenerator<
  EChatActionTypes.OpenAfterAuth,
  TOpenChatAfterAuthPayload
>(EChatActionTypes.OpenAfterAuth);

/** Action открытия чата по ЖК после авторизации */
export const openNewbuildingChatAfterAuth = actionGenerator<
  EChatActionTypes.OpenNewbuildingChatAfterAuth,
  TOpenNewbuildingChatAfterAuthPayload
>(EChatActionTypes.OpenNewbuildingChatAfterAuth);

/**
 * Action закрытия чата
 */
export const closeChat: () => TCloseChat = actionGenerator<EChatActionTypes.Close>(EChatActionTypes.Close);

export type TChatActions =
  | TOpenChat
  | TOpenChatbot
  | ReturnType<typeof openNewbuildingChat>
  | TCloseChat
  | TOpenChatAfterAuth
  | ReturnType<typeof openNewbuildingChatAfterAuth>;
